export var bodyBgColor = 'var(--_1jn6aiu0)';
export var bodyTextColor = 'var(--_1jn6aiu1)';
export var footerBgColor = 'var(--_1jn6aiu2)';